import React from "react";

import { viewBoardingPagePermissionSet } from "helpers";
import { getBoardingAppLink } from "mappers";
import { useBoardingSearchQuery } from "queries";

import { boardingResultItem } from "../resultItems";

import { ReactComponent as BoardingIcon } from "static/images/boarding-search.svg";

const boardingSection = () => {
	return {
		name: "boarding",
		title: "Boarding",
		useSearchQuery: useBoardingSearchQuery,
		renderItem: boardingResultItem,
		getIcon: () => <BoardingIcon />,
		getLink: ({ application_status, id, pended }) =>
			getBoardingAppLink(application_status, id, pended),
		requiredPermissions: viewBoardingPagePermissionSet,
	};
};

export default boardingSection;
